// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"230":"c1a5bc4df73362ba","252":"2a834f344b1642c9","368":"45360ff8ed0c0a64"}[chunkId] + ".js";
};